import React, {
  forwardRef, useImperativeHandle, useRef,
} from 'react'
import DirectoForm, { DirectoEventSaveResult, DirectoFormHandle } from '../directo-event/components/DirectoForm'

interface DirectoTabProps {
  transitOperationId: number
  directoEventId: number | null
}

export type DirectoTabHandle = {
  validateAndGet: () => Promise<DirectoEventSaveResult | null>
  isDirty: () => boolean
  isFormEnabled: () => boolean
}

const DirectoTab = forwardRef<DirectoTabHandle, DirectoTabProps>(({
  transitOperationId,
  directoEventId,
}, ref) => {
  const activeFormRef = useRef<DirectoFormHandle | null>(null)

  useImperativeHandle(ref, () => ({
    validateAndGet: async () => {
      if (!activeFormRef.current) return null
      return activeFormRef.current?.save()
    },
    isDirty: () => activeFormRef.current?.isDirty() ?? false,
    isFormEnabled: () => activeFormRef.current?.isEnabled() ?? false,
  }))

  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <section className="py-3">
            <DirectoForm
              transitOperationId={transitOperationId}
              directoEventId={directoEventId}
              ref={activeFormRef}
            />
          </section>
        </div>
      </div>
    </div>
  )
})

export default DirectoTab
